import React ,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import clinicService from '../../../../../services/clinic.service';
import AddressForm from './AddressForm';
import Loading from '../../../../common/Loading';
const AddressCard = () => {
    const {clinicId} = useParams()
    const [isError,setIsError] = useState(false)
    const [errorMessage,setErrorMessage] = useState()
    const [isEditing,setIsEditing] = useState(false)
    const [address,setAddress] = useState({
        street:"90 Sheppard Ave East",
        city:"Toronto",
        postalCode:"M1P 1A1",
        country:"Canada",
        province:"ON"
    })
    const [isLoading,setIsLoading] = useState(false)
    
    useEffect(()=>{
      
        setIsLoading(true)
        clinicService.getAddress(clinicId)
        .then(res=>{
            setAddress(res.data)
            setIsLoading(false)
           
        })
        .catch(error=>{
            if(error.response?.status === 404){
                setAddress({
                    street:"",
                    city:"",
                    postalCode:"",
                    country:"",
                    province:""
                })
                setIsLoading(false)
                setIsEditing(true)
                
            }else{
                setIsError(true)
                setErrorMessage(error.message)
                setIsLoading(false)
            }
        })
    },[])

    const updateAddress = (add)=>{
        setAddress(add)
    }
    const updateEditing = ()=>{
        setIsEditing(!isEditing)
    }
    return ( 
          <div className="info-box card mt-1">
              <i className='bi bi-geo-alt'></i>
              <div className="d-flex justify-content-between editClinic">
                    <h3>Address</h3>
                    <div className="editButton" onClick={()=>setIsEditing(!isEditing)}>
                        <i className="bi bi-pencil-square"></i>
                    </div>
             </div>
             <div>
                {isLoading? <Loading/> :
                    !isEditing ?
                                address.street+" "+address.city+" "+address.province+" "+address.postalCode+" "+address.country
                                :
                              <AddressForm address = {address} updateAddress={updateAddress} updateEditing={updateEditing} />
                }
            </div>
              
            
        </div>
     );
}
 
export default AddressCard;